import { Component, Input, OnInit } from '@angular/core';
import { UtilService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-dm-select-lives',
  templateUrl: './dm-select-lives.component.html',
  styleUrls: ['./dm-select-lives.component.scss']
})
export class DmSelectLivesComponent implements OnInit {

  @Input() config;

  constructor(
    public util: UtilService,
    public vwo: VwoService
  ) { }

  ngOnInit(): void {
  }

}
